import React, { useCallback, useEffect, useState } from "react";
// import { Button } from 'react-bootstrap';
import BootstrapTable from "fad-react-bootstrap-table-next";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import { IoCheckmarkSharp } from "react-icons/io5";
import { LiaTimesSolid } from "react-icons/lia";
import styled from "styled-components";
import { Container } from "react-bootstrap";

import { useConfig } from "./../../hooks/use-config";
import * as Constants from "./../../helpers/constants";

import "fad-react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

let controller = null;
let signal = null;

const CompareProducts = () => {
  const { clearout: clearoutConfig } = useConfig();

  const [showTable, setShowTable] = useState(false);
  const [productData, setProductData] = useState([]);
  const [limitedProductData, setLimitedProductData] = useState([]);

  const getCompareData = useCallback(() => {
    let url =
      clearoutConfig.api.baseurl + clearoutConfig.api.public_compare_products;

    if (signal) controller.abort("cancelled");

    controller = new AbortController();
    signal = controller.signal;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      },
      signal
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === Constants.CO_API.Success) {
          setProductData(res.data);
          setLimitedProductData(res.data.slice(0, 5)); // Set the first 5 rows
        }
      })
      .catch((err) => {
        console.log("compare products api error", err);
      });
  }, [clearoutConfig.api.baseurl, clearoutConfig.api.public_compare_products]);

  useEffect(() => {
    getCompareData();
  }, [getCompareData]);

  const handleCompareClick = () => {
    setShowTable(!showTable);
    if (showTable) {
      const headerElement = document.querySelector("h2.compare-plans-header");
      if (headerElement) {
        headerElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const featureFormatter = (cell, row) => {
    if (row.displayName && Object.keys(row).length === 1) {
      return <span className="fw-bold">{cell}</span>;
    } else {
      if (cell === true) {
        return <IoCheckmarkSharp size="1rem" className="compare-table-ticks" />;
      } else if (cell === false) {
        return <LiaTimesSolid size={"1rem"} className="compare-table-ticks" />;
      } else {
        return <span style={{ fontWeight: "normal" }}>{cell}</span>;
      }
    }
  };

  const rowClassName = (row, rowIndex) => {
    const highlightedFeatures = [
      "Email Verifier",
      "Form Guard",
      "Email Finder",
      "Prospecting",
      "API",
      "Integrations",
      "Support"
    ];
    if (highlightedFeatures.includes(row.displayName)) {
      return "highlighted-row";
    }
    return "";
  };

  const columns = [
    {
      dataField: "displayName",
      text: "Feature",
      formatter: featureFormatter
    },
    {
      dataField: "Freemium 100",
      text: "Freemium",
      formatter: featureFormatter
    },
    {
      dataField: "Starter 3,000",
      text: "Starter",
      formatter: featureFormatter
    },
    {
      dataField: "Pro 10K",
      text: "Pro 10K",
      formatter: featureFormatter
    },
    {
      dataField: "Pro 50K",
      text: "Pro 50K",
      formatter: featureFormatter
    },
    {
      dataField: "Pro 100K",
      text: "Pro 100K",
      formatter: featureFormatter
    },
    {
      dataField: "Pro 250K",
      text: "Pro 250K",
      formatter: featureFormatter
    },
    {
      dataField: "Pro 500K",
      text: "Pro 500K",
      formatter: featureFormatter
    },
    {
      dataField: "Pro 1M",
      text: "Pro 1M",
      formatter: featureFormatter
    },
    {
      dataField: "Pro 5M",
      text: "Pro 5M",
      formatter: featureFormatter
    }
  ];

  const StyledContainer = styled(Container)`
    .addon-title {
      font-size: 24px;
      font-weight: 700;
      text-align: center;
      margin-bottom: 10px;
    }
  `;

  return (
    <StyledContainer className="compare-products">
      <div style={{ position: "relative", display: "inline-block" }}>
        <h2 className="fw-bold">Compare Plans</h2>
        <span>Find the plan that fits your needs</span>
      </div>
      <div className="comparison-table-wrapper">
        <BootstrapTable
          keyField="displayName"
          data={showTable ? productData : limitedProductData}
          columns={columns}
          bootstrap4
          wrapperClasses={"comparison-table"}
          bsPrefix="comparison-table"
          rowClasses={rowClassName}
        />
      </div>
      <span className="give-it-shot">
        <a onClick={handleCompareClick} className="underlines mt-2">
          {showTable ? "Show Less" : "Show More"}
          <span className="feature-icon-container">
            {showTable ? (
              <FaAngleUp size={"18px"} />
            ) : (
              <FaAngleDown size={"18px"} />
            )}
          </span>
        </a>
      </span>
    </StyledContainer>
  );
};

export default CompareProducts;
